module.exports = {"name":"html5","type":"adapter","tech":"js","author":"Jordi Aguilar","version":"6.2.1","built":"2018-05-02","repo":"https://bitbucket.org/npaw/html5-adapter-js.git","libVersion":"6.2.3","features":{"buffer":"monitor","seek":"native","getters":["getPlayhead","getDuration","getIsLive","getResource"]},"ads":[]}


//////////////////
// WEBPACK FOOTER
// ./manifest.json
// module id = 29
// module chunks = 0